module.exports = __webpack_public_path__ + "img/task-1.bdc440ad.png";